import React from 'react';

import Feature from '../Feature';
import { useTranslations } from 'components/utilities';
import { DriverIcon } from '../../styles';

const DriverFeature = () => {
	const { t } = useTranslations();
	return <Feature header={<DriverIcon />} title={t('common.driver')} />;
};

export default DriverFeature;
